import type { ReactNode } from "react"

import { CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export function CardHeading({
  icon,
  children,
  className,
}: {
  icon?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <CardTitle className={cn("flex items-center gap-2", className)}>
      {icon ? <span className="size-5 text-primary">{icon}</span> : null}
      {children}
    </CardTitle>
  )
}
